import { SUGGESTIONS_ERROR } from "./const";

function action() {
  return {
    type: SUGGESTIONS_ERROR,
  };
}

export default action;
